var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-content-loading',{attrs:{"width":200,"height":90}},[_c('rect',{attrs:{"x":"7","y":"13","rx":"4","ry":"4","width":"100","height":"7"}}),_c('rect',{attrs:{"x":"7","y":"25","rx":"4","ry":"4","width":"150","height":"7"}}),_c('rect',{attrs:{"x":"7","y":"50","rx":"4","ry":"4","width":"185","height":"30"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }